import { GeneralSettingMenuType } from "../../commonTypes/generalSettingType";

export const GENERAL_SETTING_MENU: GeneralSettingMenuType[] = [
  {
    name: "Sales Templates",
    key: "PdfTemplate",
    isDeveloped: true,
  },
  {
    name: "Expense Templates",
    key: "ExpensePdfTemplates",
    isDeveloped: true,
  },
  {
    name: "HSN Checks",
    key: "HsnCheck",
    isDeveloped: true,
  },
  {
    name: "Auto Unique Number",
    key: "Unique Number",
    isDeveloped: true,
  },
  {
    name: "Miscellaneous Settings",
    key: "Miscellaneous Settings",
    isDeveloped: true,
  },
  {
    name: "Auto Invoice",
    key: "AutoInvoice",
    isDeveloped: false,
  },
];
